import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export const SearchIcon = () => (
  <div className="flex size-12 items-center justify-center rounded-full bg-primary/10">
    <MagnifyingGlassIcon className="size-6 text-primary" />
  </div>
);
